<template>
	<div ref="recoveryCodesModalRef" class="modal fade" tabindex="-1" id="recoveryCodesModal" aria-labelledby="recoveryCodesModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered sheetModal popOutModal">
			<div class="modal-content rounded-sm">
				<div class="modal-body d-flex flex-column p-4 align-items-center">
					<h3 class="fw-semi-bold m-0">Verification Successful</h3>
					<p class="text-secondary text-center mt-2">Here are your security codes. Copy and Save them somewhere safe.</p>
					<div class="d-flex flex-column w-100 align-items-center justify-content-center">
						<div class="row border shadow-sm rounded bg-light p-2">
							<div v-for="code in recoveryCodes" class="col-6 text-center">
								<pre>{{ code }}</pre>
							</div>
						</div>
						<div class="d-flex mt-4 gap-3">
							<button class="btn btn-outline-secondary rounded-pill py-6" @click="copyRecoveryCode">Copy Code</button>
							<button class="btn btn-outline-dark rounded-pill py-6" data-bs-dismiss="modal" @click="redirectToLogin">Continue</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import Modal from "bootstrap/js/dist/modal";
import apiClient from "@/utils/axios.js";
import { useHttpErrorManager } from "@/composables/useHttpErrorManager.js";
import { useToast } from "@/composables/useToast.js";
import { useAppHelpers } from "@/composables/useAppHelpers.js";
import { useRouter } from "vue-router";

const props = defineProps({
	email: { type: String, required: true },
	uid: { type: [String, Number], required: true }
});

const emits = defineEmits(['closeModal']);

const { displayToast } = useToast();
const helper = useAppHelpers();
const router = useRouter();

const recoveryModal = ref(null);
const recoveryCodesModalRef = ref(null);
const recoveryCodes = ref([]);

const recoveryCodesString = computed(() => {
	return recoveryCodes.value.join('\n');
});

const copyRecoveryCode = () => {
	helper.copyText(recoveryCodesString.value);
	displayToast('Recovery codes copied to clipboard.', 'outline-success', 5000);
}

const redirectToLogin = () => {
	router.push({ name: 'login' });
	emits('closeModal');
}

const processPostVerificationSteps = async () => {
	try{
		helper.loaderOn(recoveryCodesModalRef.value);
		const response = await apiClient.post('/auth/postAccountVerification', {
			email: props.email,
			uid: props.uid,
		});

		if(response.status >= 200 && response.status < 300){
			recoveryCodes.value = response.data.recovery_codes;
			displayToast({heading: 'Verification successful', message: 'Your account is now verified! Log in to continue.'}, 'outline-success', 10000);
			recoveryModal.value.show();
		}
		helper.loaderOff(recoveryCodesModalRef.value);
	}
	catch(error){
		let errorObj = await useHttpErrorManager().handleError(error);
		let message = errorObj['full_message'];
		displayToast(message, 'outline-danger', 8000);
		helper.loaderOff(recoveryCodesModalRef.value);
	}
}

onMounted(() => {
	let recoveryModalEl = document.getElementById('recoveryCodesModal');
	recoveryModal.value = Modal.getOrCreateInstance(recoveryModalEl);

	recoveryModalEl.addEventListener('hide.bs.modal', (event) => {
		emits('closeModal');
	})

	processPostVerificationSteps();
});
</script>

<style scoped lang="scss">

</style>